









































































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import { Location } from "vue-router";
import { formatDateString } from "@/shared/dateString";
import { formatCurrency } from "@/shared/currency";
import { bankCustodianMap } from "@/shared/types";
import {
  ReimbursementFailureResponseModel,
  ReimbursementFailureDetailModel,
  ReimbursementFailurePageRequestModel,
  reimbursementTypeMap
} from "@/admin/types";
import Pagination from "@/shared/components/ui/Pagination.vue";
import PageSizeSelectList from "@/shared/components/ui/PageSizeSelectList.vue";
import AdminUtilityReimbursementFailureDetail from "./AdminUtilityReimbursementFailureDetail.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { useNotifierStore } from "@/shared/store/notifier";
import { useReimbursementFailureStore } from "@/admin/store/reimbursementFailure";

@Component({
  components: {
    GenericLoadingSpinner,
    Pagination,
    PageSizeSelectList,
    AdminUtilityReimbursementFailureDetail
  }
})
export default class AdminUtilityReimbursementFailures extends Vue {
  formatDateString = formatDateString;
  formatCurrency = formatCurrency;
  reimbursementTypeMap = reimbursementTypeMap;
  bankCustodianMap = bankCustodianMap;

  @Prop() pageNumber: number;
  @Prop() reimbursementId: number;
  @Prop() routeToPage: (pageNumber: number, isArchived: boolean) => Location;
  @Prop() buildRoute: (query: ReimbursementFailurePageRequestModel) => Location;

  @Prop() routeToItem: (reimbursementId: number) => Location;
  notifierStore = useNotifierStore();
  reimbursementFailureStore = useReimbursementFailureStore();

  isArchived = false;
  formModel: ReimbursementFailurePageRequestModel = {
    isArchived: false,
    pageSize: 50,
    pageNumber: 1
  };

  created (): void {
    this.loadComponent();
  }

  loadComponent (): void {
    if (this.reimbursementId) {
      this.reimbursementFailureStore.loadDetailById(this.reimbursementId)
        .catch(_ => { /* noop */ });
      return;
    }
    this.formModel.pageNumber = this.pageNumber;
    this.formModel.isArchived = this.isArchived;
    this.reimbursementFailureStore.loadItems(this.formModel)
      .catch(_ => { /* noop */ });
  }

  @Watch("pageNumber")
  @Watch("isArchived")
  @Watch("reimbursementId")
  onRouteValuePageNumberChanged () {
    this.loadComponent();
  }

  get isLoading (): boolean {
    return !this.reimbursementFailureStore.isListLoaded;
  }

  get canGoBack () {
    return this.pageNumber > 1;
  }

  get showDetail () {
    return !!this.reimbursementId;
  }

  get showListing () {
    return !this.showDetail;
  }

  get fieldConfiguration () {
    return [
      { key: "reimbursementId", label: "" },
      { key: "custodian" },
      { key: "partnerName", label: "Partner" },
      { key: "employerName", label: "Employer" },
      { key: "firstName", label: "First Name" },
      { key: "lastName", label: "Last Name" },
      { key: "dateInitiated", label: "Initiated" },
      { key: "dateFailed", label: "Failed" },
      { key: "messageType", label: "Transfer Type" },
      { key: "amount", label: "Amount" },
    ];
  }
  switchArchive (isChecked: boolean) {
    const q: ReimbursementFailurePageRequestModel = {
      pageNumber: 1,
      isArchived: isChecked,
      pageSize: 50
    };
    this.$router.push(this.buildRoute(q));
  }

  switchPage (page: number) {
    const q: ReimbursementFailurePageRequestModel = {
      pageNumber: page,
      isArchived: this.isArchived,
      pageSize: 50
    };
    this.$router.push(this.buildRoute(q));
  }

  viewClick (item: ReimbursementFailureResponseModel) {
    this.$router.push(this.routeToItem(item.reimbursementId));
  }

  onResolveClick (item) {
    this.showResolveDetailModal = { open: true, value: item };
  }

  showResolveDetailModal = { open: false, value: null };

  onResolveDetailModalClosed (reimbursementId) {
    if (reimbursementId) {
      this.reimbursementFailureStore.resolveById(reimbursementId).then(v => {
        this.reimbursementFailureStore.removeFromListById(reimbursementId);
        this.notifierStore.setSuccess("Reimbursement Failure item has been archived.");
      });
    }
    this.showResolveDetailModal = { open: false, value: null };
  }
}
